// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 996;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    pointer-events: none;
}

.wizard-overlay.active {
    opacity: 1;
    pointer-events: auto;
}

.wizard-section-transition {
    transition: all 0.3s ease-in-out;
}

.wizard-highlight {
    position: relative;
    z-index: 997;
    background-color: white!important;
    transition: all 0.05s ease-in-out;
    box-shadow: 0 0 0 2px #5bb752;
}
.wizard-active #controls > *:not(.wizard-highlight),
.wizard-active #quote-controls:not(.wizard-highlight) {
    opacity: 0.1;
    transition: opacity 0.1s ease-in-out;
}
#controls, #quote-controls {
    transition: background-color 0.3s ease-in-out;
}

.wizard-active #controls,
.wizard-active #quote-controls {
    background-color: #555;
}

.wizard-content {
    position: fixed;
    background: white;
    padding: 20px;
    border: 2px solid #5bb752;
    border-radius: 0;
    max-width: 400px;
    z-index: 998;
    transition: all 0.2s ease;
}

.wizard-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
}

.wizard-button {
    padding: 10px 20px;
    background: none;
    border: 2px solid #5bb752;
    color: #5bb752;
    cursor: pointer;
    font-weight: bold;
    transition: all 0.15s ease;
}

.wizard-button:hover {
    background: #5bb752;
    color: white;
}

.wizard-help-icon {
    position: fixed;
    width: 40px;
    height: 40px;
    background: white;
    border: 2px solid #5bb752;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
    z-index: 995;
}

/* Desktop positioning */
@media (min-width: 1025px) {
    .wizard-help-icon {
        bottom: 20px;
        left: 20px;
    }
}

/* Mobile positioning */
@media (max-width: 1024px) {
    .wizard-help-icon {
        top: 80px;
        right: 20px;
    }
    
    .wizard-content {
        position: fixed;
        left: 15px;
        right: 15px;
        width: calc(100% - 30px);
        max-width: none;
        margin: 0;
        transform: none !important;
    }

    /* Steps 1-3: Below controls */
    .wizard-content[data-step="1"],
    .wizard-content[data-step="2"],
    .wizard-content[data-step="3"] {
        top: auto;
        bottom: 20px;
    }

    /* Step 4: Above quote controls */
    .wizard-content[data-step="4"] {
        bottom: auto;
        /* Position above #quote-controls */
        top: auto;
        bottom: calc(100vh - var(--quote-controls-top) + 20px);
    }
}

.wizard-progress {
    font-size: 0.8em;
    color: #666;
    margin-bottom: 10px;
}

.wizard-content p {
    margin: 0 0 15px 0;
    line-height: 1.5;
    color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/helpers/wizard/wizard-styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,YAAY;IACZ,UAAU;IACV,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iCAAiC;IACjC,iCAAiC;IACjC,6BAA6B;AACjC;AACA;;IAEI,YAAY;IACZ,oCAAoC;AACxC;AACA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;IAC1B,YAAY;AAChB;;AAEA,wBAAwB;AACxB;IACI;QACI,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA,uBAAuB;AACvB;IACI;QACI,SAAS;QACT,WAAW;IACf;;IAEA;QACI,eAAe;QACf,UAAU;QACV,WAAW;QACX,wBAAwB;QACxB,eAAe;QACf,SAAS;QACT,0BAA0B;IAC9B;;IAEA,8BAA8B;IAC9B;;;QAGI,SAAS;QACT,YAAY;IAChB;;IAEA,iCAAiC;IACjC;QACI,YAAY;QACZ,mCAAmC;QACnC,SAAS;QACT,sDAAsD;IAC1D;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf","sourcesContent":[".wizard-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.7);\n    z-index: 996;\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n    pointer-events: none;\n}\n\n.wizard-overlay.active {\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.wizard-section-transition {\n    transition: all 0.3s ease-in-out;\n}\n\n.wizard-highlight {\n    position: relative;\n    z-index: 997;\n    background-color: white!important;\n    transition: all 0.05s ease-in-out;\n    box-shadow: 0 0 0 2px #5bb752;\n}\n.wizard-active #controls > *:not(.wizard-highlight),\n.wizard-active #quote-controls:not(.wizard-highlight) {\n    opacity: 0.1;\n    transition: opacity 0.1s ease-in-out;\n}\n#controls, #quote-controls {\n    transition: background-color 0.3s ease-in-out;\n}\n\n.wizard-active #controls,\n.wizard-active #quote-controls {\n    background-color: #555;\n}\n\n.wizard-content {\n    position: fixed;\n    background: white;\n    padding: 20px;\n    border: 2px solid #5bb752;\n    border-radius: 0;\n    max-width: 400px;\n    z-index: 998;\n    transition: all 0.2s ease;\n}\n\n.wizard-navigation {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.wizard-button {\n    padding: 10px 20px;\n    background: none;\n    border: 2px solid #5bb752;\n    color: #5bb752;\n    cursor: pointer;\n    font-weight: bold;\n    transition: all 0.15s ease;\n}\n\n.wizard-button:hover {\n    background: #5bb752;\n    color: white;\n}\n\n.wizard-help-icon {\n    position: fixed;\n    width: 40px;\n    height: 40px;\n    background: white;\n    border: 2px solid #5bb752;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    z-index: 995;\n}\n\n/* Desktop positioning */\n@media (min-width: 1025px) {\n    .wizard-help-icon {\n        bottom: 20px;\n        left: 20px;\n    }\n}\n\n/* Mobile positioning */\n@media (max-width: 1024px) {\n    .wizard-help-icon {\n        top: 80px;\n        right: 20px;\n    }\n    \n    .wizard-content {\n        position: fixed;\n        left: 15px;\n        right: 15px;\n        width: calc(100% - 30px);\n        max-width: none;\n        margin: 0;\n        transform: none !important;\n    }\n\n    /* Steps 1-3: Below controls */\n    .wizard-content[data-step=\"1\"],\n    .wizard-content[data-step=\"2\"],\n    .wizard-content[data-step=\"3\"] {\n        top: auto;\n        bottom: 20px;\n    }\n\n    /* Step 4: Above quote controls */\n    .wizard-content[data-step=\"4\"] {\n        bottom: auto;\n        /* Position above #quote-controls */\n        top: auto;\n        bottom: calc(100vh - var(--quote-controls-top) + 20px);\n    }\n}\n\n.wizard-progress {\n    font-size: 0.8em;\n    color: #666;\n    margin-bottom: 10px;\n}\n\n.wizard-content p {\n    margin: 0 0 15px 0;\n    line-height: 1.5;\n    color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
